import React from 'react';
import { Flex, Spinner } from '@goodrx/matisse';
import { EmptyState } from 'app/components/core';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe } from '@stripe/stripe-js';
import Settings from 'app/config/settings';
import { isClient } from 'app/lib/utils';
import { PaymentForm } from 'app/components/payment/PaymentForm';
import { PaymentMethodsList } from 'app/components/payment/PaymentMethodsList';
import { WidgetStates, PaymentWidgetReturnType, CommonProps } from 'app/components/payment/types';

const StateComponents = {
  [WidgetStates.FETCHING]: () => (
    <Flex justifyContent="center" p={10}>
      <Spinner />
    </Flex>
  ),
  [WidgetStates.LIST]: (props: PaymentWidgetReturnType) => <PaymentMethodsList {...props} />,
  [WidgetStates.FORM]: ({ paymentFormRef }: PaymentWidgetReturnType) => <PaymentForm ref={paymentFormRef} />,
  [WidgetStates.EMPTY_LIST]: ({ setPaymentState }: CommonProps) => (
    <EmptyState
      icon=""
      title="No Payment Methods"
      description="Add a card below to make checking out even easier"
      button="+ Add A Card"
      onClick={() => setPaymentState(WidgetStates.FORM)}
    />
  ),
};

let stripePromise: PromiseLike<Stripe | null> | Stripe | null = null;

if (isClient()) {
  loadStripe.setLoadParameters({ advancedFraudSignals: false });
  stripePromise = loadStripe(Settings.StripePublicKey);
}

export const PaymentWidget = (props: PaymentWidgetReturnType & { children?: React.ReactNode }) => {
  const PaymentComponent = StateComponents[props.paymentState];

  return (
    <Elements stripe={stripePromise}>
      {props.children}
      <PaymentComponent {...props} />
    </Elements>
  );
};
